/**
 * Custom JS - Theme customizations
 * Wishlist functionality handled by wishlist-module.js (Wishlist Hero SDK).
 */

(function () {
  function initWishlist() {
    if (typeof WishlistManager !== "undefined") {
      console.log("[custom.js] Initializing WishlistManager");
      WishlistManager.init();
    } else {
      console.warn(
        "[custom.js] WishlistManager not found - ensure wishlist-module.js is loaded",
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlist);
  } else {
    initWishlist();
  }
})();
